import { StarFilled } from '@ant-design/icons'
import React from 'react'
import './AdnStar.css'

export const AdnStar = () => {
  return <StarFilled className="starColor"/>
}
